// removed by extract-text-webpack-plugin
module.exports = {"promoContainer":"VerifiedTradePromo__promoContainer__c8fd1817","textContainer":"VerifiedTradePromo__textContainer__c8fd1817","highlightedText":"VerifiedTradePromo__highlightedText__c8fd1817","infoContainer":"VerifiedTradePromo__infoContainer__c8fd1817","infoIcon":"VerifiedTradePromo__infoIcon__c8fd1817","tooltip":"VerifiedTradePromo__tooltip__c8fd1817","top":"VerifiedTradePromo__top__c8fd1817","left":"VerifiedTradePromo__left__c8fd1817","tooltipInner":"VerifiedTradePromo__tooltipInner__c8fd1817","inShippingModal":"VerifiedTradePromo__inShippingModal__c8fd1817"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/VerifiedTradePromo.scss
// module id = 1355
// module chunks = 4 14